document.addEventListener( 'DOMContentLoaded', () => {
	const grids = document.querySelectorAll( '.conferences-grid' );

	grids.forEach( ( grid ) => {
		const wrapper = grid.parentElement.querySelector( '.conferences-load-more-wrapper' );
		const button = wrapper?.querySelector( '.conferences-load-more-btn' );
		const loader = wrapper?.querySelector( '.conferences-loader' );

		if ( ! wrapper || ! button ) return;

		const loadStep = parseInt( grid.dataset.loadStep, 10 ) || 6;

		button.addEventListener( 'click', ( e ) => {
			e.preventDefault();

			if ( wrapper.classList.contains( 'is-loading' ) ) return;

			wrapper.classList.add( 'is-loading' );

			// Show loader
			if ( loader ) {
				loader.classList.add( 'is-active' );
			}

			setTimeout( () => {
				const hiddenCards = grid.querySelectorAll( '.conference-card.is-hidden' );

				Array.from( hiddenCards )
					.slice( 0, loadStep )
					.forEach( ( card ) => {
						card.classList.remove( 'is-hidden' );
					} );

				// Hide button if no more hidden cards
				if ( ! grid.querySelector( '.conference-card.is-hidden' ) ) {
					wrapper.style.display = 'none';
				} else {
					wrapper.classList.remove( 'is-loading' );
				}

				// Hide loader
				if ( loader ) {
					loader.classList.remove( 'is-active' );
				}
			}, 2000 ); // 2 seconds delay
		} );
	} );
} );
